(function () {
  'use strict';

  /* FORCE SCROLL TO TOP ON RELOAD */
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);

  /* PRE-FETCH VIDEO immediately — loading screen buys us 1.85s of buffer time */
  var heroVideo = document.getElementById('hero-video-el');
  if (heroVideo) {
    heroVideo.preload = 'auto';
    heroVideo.addEventListener('canplay', function () {
      heroVideo.classList.add('is-playing');
    }, { once: true });
    heroVideo.load();
  }

  /* PRE-FETCH all page images during the loading animation window */
  var imgs = document.querySelectorAll('img[loading="lazy"], img[loading="eager"]');
  imgs.forEach(function (img) {
    if (img.dataset.src) { img.src = img.dataset.src; }
    else if (img.src) {
      var pre = new Image();
      pre.src = img.src;
    }
  });

  /* CURSOR — GPU-accelerated transforms instead of left/top */
  const cursor = document.getElementById('aria-cursor');
  let mouseX = 0, mouseY = 0;

  document.addEventListener('mousemove', function (e) {
    mouseX = e.clientX; mouseY = e.clientY;
    if (cursor) { cursor.style.transform = 'translate(' + (mouseX - 9.5) + 'px,' + (mouseY - 9.5) + 'px)'; }
  }, { passive: true });

  document.querySelectorAll('a, button, input, .aria-tease__cell, .aria-social-selector').forEach(function (el) {
    el.addEventListener('mouseenter', function () {
      if (cursor) { cursor.style.width = '29px'; cursor.style.height = '29px'; }
    });
    el.addEventListener('mouseleave', function () {
      if (cursor) { cursor.style.width = '19px'; cursor.style.height = '19px'; }
    });
  });

  /* PAGE LOAD - hero reveals after loading screen starts to dismiss */
  var hero = document.getElementById('aria-hero');

  /* SCROLL REVEALS */
  var revealEls = document.querySelectorAll('.aria-reveal');
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  revealEls.forEach(function (el) { revealObserver.observe(el); });

  /* GALLERY – column parallax */
  var galleryCols = Array.from(document.querySelectorAll('.aria-gallery__col, .aria-gallery__word'));
  var colStates = galleryCols.map(function (col) {
    return {
      el: col,
      speed: parseFloat(col.getAttribute('data-y-speed')) || 1
    };
  });

  function updateGalleryCols() {
    var wh = window.innerHeight;
    var s = window.scrollY; // Use direct scroll for simple columns if outside the smooth loop, but we will attach to parallaxLoop
  }

  /* ─── LOADING SVG: JS-driven adaptive sketch animation ─── */
  (function () {
    var svg = document.getElementById('aria-loading-svg');
    var loadingScreen = document.getElementById('aria-loading');
    if (!svg || !loadingScreen) return;

    var INK = '#1c1e1d';
    var isLoaded = false;
    var currentSpeed = 1.0;

    if (document.readyState === 'complete') {
      isLoaded = true;
    } else {
      window.addEventListener('load', function() {
        isLoaded = true;
        if (typeof checkDismiss === 'function') checkDismiss();
      });
    }

    var borderEl = svg.querySelector('#aria-stamp-border');
    var starPaths = Array.from(svg.querySelectorAll('.aria-stamp-star'));
    var mainG = svg.querySelector('g > g');
    var bodyG = mainG ? mainG.children[1] : null;
    var outerWrapG = mainG ? mainG.children[2] : null;
    var bodyPaths = bodyG ? Array.from(bodyG.querySelectorAll('path, polygon, rect')) : [];
    bodyPaths = bodyPaths.filter(function (p) { return !p.classList.contains('aria-stamp-star'); });
    var ariaPaths = outerWrapG ? Array.from(outerWrapG.querySelectorAll('path, polygon, rect')) : [];

    function prep(el) {
      if (!el) return;
      var len = 200;
      try { if (el.getTotalLength) len = el.getTotalLength(); } catch (e) {}
      el.style.fill = 'transparent';
      el.style.strokeDasharray = len;
      el.style.strokeDashoffset = len;
      el.style.transition = 'none';
      el.style.opacity = '1';
    }

    if (borderEl) prep(borderEl);
    starPaths.forEach(prep);
    bodyPaths.forEach(prep);
    ariaPaths.forEach(prep);

    function draw(el, dur, delay) {
      if (!el) return;
      setTimeout(function () {
        // ALWAYS use the full duration, never speed up
        el.style.transition = 'stroke-dashoffset ' + dur + 's cubic-bezier(0.25, 0.1, 0.1, 1)';
        el.style.strokeDashoffset = '0';
      }, delay);
    }

    function fillAll(elements, delay) {
      setTimeout(function () {
        elements.forEach(function (el) {
          if (!el) return;
          el.style.transition = 'fill 0.4s ease';
          el.style.fill = INK;
        });
      }, delay);
    }

    // Start sequences - always use fixed timeline
    function startAnimation() {
      // Force repaint to lock in the 'prep' (hidden) state
      void svg.offsetWidth;

      var p1_dur = 0.35;
      var p1_gap = Math.max(8, Math.floor(670 / (bodyPaths.length || 1)));
      bodyPaths.forEach(function (el, i) { draw(el, p1_dur, 100 + i * p1_gap); });
      starPaths.forEach(function (el, i) { draw(el, 0.5, 100 + i * 150); });

      var p2_start = 850;
      var p2_gap = Math.max(8, Math.floor(700 / (ariaPaths.length || 1)));
      ariaPaths.forEach(function (el, i) { draw(el, 0.4, p2_start + i * p2_gap); });

      var fill_start = 1750; // Closer to the 1.85s mark
      fillAll(bodyPaths.concat(starPaths, ariaPaths), fill_start);

      var oval_start = 1600;
      draw(borderEl, 0.6, oval_start);
    }

    // Wait for one frame to be absolutely sure the CSS 'none' transition in prep() is processed
    requestAnimationFrame(function() {
      requestAnimationFrame(startAnimation);
    });

    // Fixed Dismissal - Animation finishes drawing at 1850ms. Let it hold to show the completed logo.
    var HOLD_TIME = 2600; 
    var animFinished = false;

    // Wait until drawing is done (1850) + hold time
    setTimeout(function() {
      animFinished = true;
      checkDismiss();
    }, HOLD_TIME);

    // Fallback: if load takes > 5s, force dismiss to show site anyway
    var fallbackTimeout = setTimeout(function() {
      if (!animFinished) return; // wait at least HOLD_TIME
      isLoaded = true;
      checkDismiss();
    }, 5000);

    function checkDismiss() {
      // Dismiss when BOTH the 1.85s animation is complete AND the page is loaded (or fallback hit).
      if (animFinished && isLoaded) {
        if (!document.body.classList.contains('aria-body-ready')) {
          clearTimeout(fallbackTimeout);
          dismissLoading();
        }
      }
    }

    function dismissLoading() {
      document.body.classList.add('aria-body-ready');
      if (loadingScreen) loadingScreen.classList.add('aria-loaded');
      setTimeout(function () { if (hero) hero.classList.add('aria-loaded'); }, 100);
      setTimeout(function () { if (loadingScreen) loadingScreen.style.display = 'none'; }, 700);
    }

    // Kick off dismissal check
    setTimeout(checkDismiss, 50);

  })();


  /* ─── NEEDLE & THREAD ANIMATION ─── */
  var needleSection = document.getElementById('aria-thread-to-stats-section');
  var STATS_REVEALED = false;

  function playNeedleToStatsAnimation() {
    var needleWrap = document.getElementById('aria-needle-animation-wrap');
    var needle = document.getElementById('aria-needle-only');
    var needlePathInner = document.getElementById('aria-needle-path-inner');
    var threadContainer = document.getElementById('aria-thread-container');
    var threadPaths = document.querySelectorAll('.aria-thread-path');
    var statsWrap = document.getElementById('aria-stats-wrap');

    if (!needleWrap || !needle || !threadContainer || !statsWrap) return;
    if (STATS_REVEALED) return;
    STATS_REVEALED = true;

    var RUST  = '#52011a';
    var INK   = '#1c1e1d';

    /* ── Helper: measure & prep a path for dashoffset drawing ── */
    function prepPath(path, opts) {
      var len = 1000;
      try { if (path.getTotalLength) len = path.getTotalLength(); } catch (e) {}
      if (len < 1) len = 1000;
      path.style.transition = 'none';
      path.style.fill = 'transparent';
      path.style.stroke = RUST;
      path.style.strokeWidth = '3';
      path.style.strokeLinecap = 'round';
      path.style.strokeDasharray = len + 'px';
      path.style.strokeDashoffset = len + 'px';
      path.style.opacity = (opts && opts.hidden) ? '0' : '1';
      return len;
    }

    /* ── Helper: draw a path by animating its dashoffset to 0 ── */
    function drawPath(path, durationMs, delayMs) {
      setTimeout(function () {
        path.style.transition = 'stroke-dashoffset ' + (durationMs / 1000).toFixed(2) + 's cubic-bezier(0.4, 0, 0.2, 1)';
        path.style.strokeDashoffset = '0px';
      }, delayMs);
    }

    /* ── Reset needle: start above viewport, invisible stroke ── */
    needle.style.transition = 'none';
    needle.style.opacity = '1';
    needle.style.transform = 'translateY(-80px) scale(1.06)';

    /* ── Prep all paths ── */
    var needleLen = needlePathInner ? prepPath(needlePathInner) : 0;
    var threadArr = Array.from(threadPaths);
    // Threads start fully hidden — they only appear after needle has landed
    threadArr.forEach(function (p) { prepPath(p, { hidden: true }); });

    /* Force layout so CSS resets apply before transitions start */
    void needleWrap.getBoundingClientRect();

    /* ─────────────────────────────────────────────────────
       PHASE 1 — Needle descends into frame     (t = 200ms)
    ───────────────────────────────────────────────────── */
    var T = 200;

    setTimeout(function () {
      needle.style.transition = 'transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)';
      needle.style.transform = 'translateY(0) scale(1)';
    }, T);

    /* Needle draws itself stroke-by-stroke as it lands */
    var NEEDLE_DUR = 1600;   // ms — slow, deliberate stroke
    if (needlePathInner) {
      drawPath(needlePathInner, NEEDLE_DUR, T + 500);
    }

    /* ─────────────────────────────────────────────────────
       PHASE 2 — Needle stabs into cloth        (after draw)
       Fast plunge → gentle bounce settle
    ───────────────────────────────────────────────────── */
    var PHASE2 = T + 500 + NEEDLE_DUR + 150;   // ≈ 2.45 s

    setTimeout(function () {
      needle.style.transition = 'transform 0.25s cubic-bezier(0.7, 0, 1, 1)';
      needle.style.transform = 'translateY(22px) scale(0.93)';
    }, PHASE2);

    setTimeout(function () {
      needle.style.transition = 'transform 0.45s cubic-bezier(0.2, 0.9, 0.4, 1)';
      needle.style.transform = 'translateY(10px) scale(0.97)';
    }, PHASE2 + 260);

    /* ─────────────────────────────────────────────────────
       PHASE 3 — Thread draws simultaneously from both sides
       idx 1 = left arc (draws from outer-left toward needle)
       idx 2 = lower closing segment (same side, fires in sync)
       idx 0 = right loop (draws from outer-right toward needle)
       All start at exactly the same moment.
    ───────────────────────────────────────────────────── */
    var THREAD_START = PHASE2 + 260 + 600;

    // Reveal thread paths (fade in) just as they start drawing
    setTimeout(function () {
      threadArr.forEach(function (p) {
        p.style.transition = 'opacity 0.3s ease';
        p.style.opacity = '1';
      });
    }, THREAD_START - 50);

    // Left side: idx 1 (main arc) + idx 2 (closing bottom) — start together
    if (threadArr[1]) drawPath(threadArr[1], 2200, THREAD_START);
    if (threadArr[2]) drawPath(threadArr[2], 1000, THREAD_START);

    // Right side: idx 0 starts at the same moment
    if (threadArr[0]) drawPath(threadArr[0], 2200, THREAD_START);

    // INK_START is based on the longest thread segment finishing
    var INK_START = THREAD_START + 2200 + 600;

    /* ─────────────────────────────────────────────────────
       PHASE 4 — Needle goes ink black; thread fills rust red
    ───────────────────────────────────────────────────── */
    setTimeout(function () {
      // Needle: stroke + fill both go black
      if (needlePathInner) {
        needlePathInner.style.transition = 'stroke 1s ease, fill 1s ease';
        needlePathInner.style.stroke = INK;
        needlePathInner.style.fill = INK;
      }
    }, INK_START);

    setTimeout(function () {
      // Thread: keep stroke rust, flood fill in as rust red
      threadArr.forEach(function (path) {
        path.style.transition = 'fill 1.2s ease';
        path.style.fill = RUST;
      });
    }, INK_START + 200);


    /* ─────────────────────────────────────────────────────
       PHASE 5 — Fade out animation, reveal stats
    ───────────────────────────────────────────────────── */
    var FADE_START = INK_START + 1400;

    setTimeout(function () {
      needleWrap.style.transition = 'opacity 1.4s ease';
      needleWrap.style.opacity = '0';
      needleWrap.style.pointerEvents = 'none';

      statsWrap.style.opacity = '1';
      statsWrap.style.pointerEvents = 'auto';

      setTimeout(function () {
        var middleCol = document.querySelector('.aria-stat-middle');
        if (middleCol) {
          middleCol.style.opacity = '1';
          middleCol.style.transform = 'translate(0) scale(1)';
        }
        setTimeout(function () {
          document.querySelectorAll('.aria-stat-side').forEach(function (col) {
            col.style.opacity = '1';
            col.style.transform = 'translate(0) scale(1)';
          });
        }, 600);
      }, 600);
    }, FADE_START);
  }

  var animationObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        playNeedleToStatsAnimation();
        animationObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.45 });

  if (needleSection) {
    requestAnimationFrame(function () {
      animationObserver.observe(needleSection);
    });
  }

  /* ─── PARALLAX: lerp-smoothed rAF loop (scroll-gated) ─── */

  var parallaxBack = document.getElementById('aria-parallax-back');
  var parallaxImage = document.getElementById('aria-parallax-image');
  var parallaxContent = document.getElementById('aria-parallax-content');
  var parallaxNum = document.getElementById('aria-parallax-num');
  var manifSection = parallaxNum ? parallaxNum.closest('.aria-manifesto') : null;
  var manifInner = document.querySelector('.aria-manifesto__inner');
  var galleryWrapper = document.getElementById('aria-gallery'); // cached once
  var wh = window.innerHeight;

  // Smoothed scroll target
  var scrollTarget = 0, scrollCurrent = 0;
  var LERP = 0.09;
  var parallaxRunning = false;

  function lerp(a, b, t) { return a + (b - a) * t; }

  function parallaxLoop() {
    scrollTarget = window.scrollY;
    scrollCurrent = lerp(scrollCurrent, scrollTarget, LERP);
    var s = scrollCurrent;

    // Batch all DOM reads first
    var manifRect = manifSection ? manifSection.getBoundingClientRect() : null;
    // Gallery Columns — parallax effect
    // galleryWrapper is cached at init to avoid per-frame DOM queries (forced reflow)
    if (galleryWrapper) {
      var gRect = galleryWrapper.getBoundingClientRect();
      var isMobile = window.innerWidth <= 768;

      // Calculate a progress from 0 (top of window) to 1 (bottom of window)
      var gProgress = (wh - gRect.top) / (wh + gRect.height);
      
      // Only animate if near or inside viewport
      if (gProgress > -0.2 && gProgress < 1.2) {
        var yOffsetBase = (0.5 - gProgress) * wh; // Range bounds [-0.5 * wh, 0.5 * wh]
        colStates.forEach(function (cs) {
          var speed = cs.speed;
          // Subtler on mobile
          var intensity = isMobile ? 0.8 : 1.5;
          var yOffset = yOffsetBase * (speed - 1) * intensity;
          cs.el.style.transform = 'translateY(' + yOffset + 'px)';
        });
      }
    }

    // Manifesto quote card — same 3D shadow treatment
    if (manifInner && manifRect) {
      // Shadows removed completely from js per requirements
    }

    // Stop loop once scroll settles (within 0.5px)
    if (Math.abs(scrollCurrent - scrollTarget) > 0.5) {
      requestAnimationFrame(parallaxLoop);
    } else {
      parallaxRunning = false;
    }
  }

  function startParallax() {
    if (!parallaxRunning) {
      parallaxRunning = true;
      requestAnimationFrame(parallaxLoop);
    }
  }

  window.addEventListener('scroll', startParallax, { passive: true });
  window.addEventListener('resize', function () { wh = window.innerHeight; }, { passive: true });
  startParallax(); // initial run

  /* NAVBAR SCROLL TOGGLE */
  var navBar = document.querySelector('.aria-nav');
  var lastScrollY = window.scrollY;

  function handleNavScroll() {
    if (!navBar) return;
    var currentScrollY = window.scrollY;

    if (currentScrollY > window.innerHeight * 0.5) {
      navBar.classList.add('is-visible');

      // Check scroll direction to toggle CSS class-based morph animation
      if (currentScrollY > lastScrollY) {
        // Scrolling down
        navBar.classList.add('scroll-down');
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up
        navBar.classList.remove('scroll-down');
      }
    } else {
      navBar.classList.remove('is-visible');
    }

    lastScrollY = currentScrollY;
  }
  window.addEventListener('scroll', handleNavScroll, { passive: true });
  handleNavScroll();

  /* SOCIAL SELECTOR */
  window.ariaToggleSocial = function () {
    var selector = document.getElementById('aria-social-selector');
    var input = document.getElementById('aria-social-input');
    if (!selector || !input) return;

    var current = selector.getAttribute('data-active');
    var next = current === 'ig' ? 'linkedin' : 'ig';

    selector.setAttribute('data-active', next);
    input.placeholder = next === 'ig' ? 'Social Media Link (Optional)' : 'Social Media Link (Optional)';
  };

  /* MARQUEE PAUSE */
  var marqueeTrack = document.querySelector('.aria-marquee-track');
  var strip = document.querySelector('.aria-marquee-strip');
  if (strip && marqueeTrack) {
    strip.addEventListener('mouseenter', function () { marqueeTrack.style.animationPlayState = 'paused'; });
    strip.addEventListener('mouseleave', function () { marqueeTrack.style.animationPlayState = 'running'; });
  }
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const targetId = this.getAttribute('href');
    if (targetId === '#') return;
    const targetEl = document.querySelector(targetId);
    if (targetEl) {
      window.scrollTo({
        top: targetEl.offsetTop,
        behavior: 'smooth'
      });
    }
  });
});

})();